import { Paths, PathValue } from "@mctypes/global.types";
import React from "react";
import { McInputNew, McTextAreaNew } from "../../../../../../components";
import { IGKMaalingAvLydtrykkResultater, IGKRapport } from "@mcapps/shared/reportSchemas/gkReportSchema";
import ReportDocxImageContainer from "../../../ReportBoard/ReportDocxImageContainer";
import { Paper, Stack, Title } from "@mantine/core";
const MaalingAvLydtrykk: React.FC<{
  onUpdateEditData: <P extends Paths<IGKRapport, 4>>(path: P, value: PathValue<IGKRapport, P>) => void;
  data: IGKMaalingAvLydtrykkResultater;
}> = ({ data, onUpdateEditData }) => {
  return (
    <Paper withBorder p="sm" radius="sm" bg="#fdfdff">
      <Stack gap="xs">
        <Title order={4} fw={400}>Måling av lydtrykk</Title>
        <div className="d-flex flex-column">
          <McInputNew
            label="Fyll inn høyden på lukeåpningen (cm):"
            value={data.inndata.hoeydePaaLukeaapning}
            normalizeNumbers={true}
            type="text"
            onBlur={(e) =>
              onUpdateEditData("testResultater.maalingAvLydtrykk.inndata.hoeydePaaLukeaapning", Number(e.target.value))
            }
            className="w-25"
          />
        </div>
        <div className="d-flex flex-column mt-4">
          <McInputNew
            label="Fyll inn målt A-vektet lydtrykk (dB):"
            value={data.inndata.maaltLydtrykk}
            normalizeNumbers={true}
            type="text"
            onBlur={(e) =>
              onUpdateEditData("testResultater.maalingAvLydtrykk.inndata.maaltLydtrykk", Number(e.target.value))
            }
            className="w-25"
          />
        </div>
        <div className="mt-4">
          <ReportDocxImageContainer docxImageTag="maalingAvLydtrykk" title="Bilde av målepunkt" />
          <div className="w-50">
            <McTextAreaNew
              label="Kommentar:"
              value={data.inndata.kommentar}
              onChange={(e) => onUpdateEditData("testResultater.maalingAvLydtrykk.inndata.kommentar", e.target.value)}
            />
          </div>
        </div>
      </Stack>
    </Paper>
  );
};
export default MaalingAvLydtrykk;